var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaultTooltipBarHowItWorks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05859 2.31445C8.97375 3.59058 10.2244 4.53565 11.4287 4.10547L11.8809 3.94336L12.8857 5.68555C12.4315 6.05635 12.178 6.56955 12.124 7.09961L10.2979 7.68359C10.3166 7.56343 10.3301 7.44086 10.3301 7.31543C10.3301 6.00657 9.26872 4.94539 7.95996 4.94531C6.65113 4.94531 5.58984 6.00652 5.58984 7.31543C5.58985 7.43164 5.60102 7.54549 5.61719 7.65723L3.9834 7.13477C3.93727 6.59236 3.68488 6.0645 3.2207 5.68555L4.22559 3.94336L4.67676 4.10547C5.88121 4.53607 7.1327 3.59074 7.04785 2.31445H9.05859Z",
    fill: "#1A1B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 9.54004V15.6201L2 13.9141V7.83398L7.33301 9.54004ZM14 13.9141L8.66602 15.6201V9.54004L14 7.83398V13.9141Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultTooltipBarHowItWorks);
export default __webpack_public_path__ + "static/media/vault-tooltip-bar-how-it-works.5e45c0f76dd4c96943f505f592ae3c57.svg";
export { ForwardRef as ReactComponent };